/**
 * 페이지 관련 UI 문자열 리소스
 * 로그인, 이용권 선택 등 페이지 레벨 문자열
 */
export const pageStr = {
  login: {
    title: '로그인',
    botSelect: 'Bot을 선택해주세요.',
    botNumber: '{num}번',
    idRequired: '아이디를 입력해주세요.',
    pwRequired: '비밀번호를 입력해주세요.',
    invalidCredentials: '아이디 또는 비밀번호가 일치하지 않습니다.',
  },
  licenseSelect: {
    title: '이용권 선택',
  },
  bottomPanel: {
    tradeHistory: '거래 내역',
    log: '로그',
  },
  monitor: {
    symbol: '종목',
    time: '시간',
    status: '현황',
    action: '동작',
  },
  progress: {
    completed: '{completed} / {total} 완료',
  },
};
